module.exports = __webpack_public_path__ + "static/img/loginLogin.c8ae839.png";